export default {
  statusActivated: 'activated',
  statusCompleted: 'completed',
  statusCancelled: 'cancelled',
  statusWaiting: 'waiting',
  statusDraft: 'draft',
  statusArchive: 'archive',
  statusLabel(status) {
    switch(status) {
      case this.statusActivated:
        return Core.Definition.getDefinition('Activé');
        break
      case this.statusCompleted:
        return Core.Definition.getDefinition('Complété');
        break
      case this.statusCancelled:
        return Core.Definition.getDefinition('Annullé');
        break
      case this.statusWaiting:
        return Core.Definition.getDefinition('En attente');
        break
      case this.statusDraft:
        return Core.Definition.getDefinition('Brouillon');
        break
      case this.statusArchive:
        return Core.Definition.getDefinition('Archivé');
        break
      default:
        return ''
        break
    }
  },
  statusOptions(keys) {
    if (keys === undefined) {
      keys = [this.statusActivated, this.statusCompleted, this.statusCancelled, this.statusWaiting ]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.statusLabel(key)
          }
      )
    }
    return options
  },
  evalPayments(regularPrice, isTaxable, periodPaymentLength, periodPayment, periodPaymentInterval,  method, status, format) {
    if (format === undefined || format === '') {
      format = 'YYYY-MM-DD'
    }
    if (status === undefined || status === '') {
      status = 'waiting'
    }
    if (method === undefined || method === '') {
      method = 'CC'
    }
    let start = ''
    let payments = []
    for (let i = 0; i < periodPaymentLength; i++) {
      start = Core.Date.calc(periodPayment, periodPaymentInterval, 'YYYY-MM-DD', start)
      payments.push({
        'date': Core.Date.format(start, format),
        'amount': regularPrice,
        'total': Core.Commerce.total(regularPrice, Core.Setting.getTaxes()),
        'method': method,
        'status': status
      })
    }
    return payments
  }
}
